import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const [languages, setLanguages] = useState([
    { code: 'en', name: 'English', flag: '🇬🇧', flagUrl: 'https://flagcdn.com/gb.svg' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', flagUrl: 'https://flagcdn.com/fr.svg' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹', flagUrl: 'https://flagcdn.com/it.svg' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷', flagUrl: 'https://flagcdn.com/tr.svg' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦', flagUrl: 'https://flagcdn.com/sa.svg' }
  ]);

  const currentLang = (i18n.language || 'fr').slice(0, 2);

  // Trouver la langue actuelle pour afficher son drapeau
  const currentLanguage = languages.find(lang => lang.code === currentLang);

  useEffect(() => {
    const saved = (localStorage.getItem('i18nextLng') || currentLang).slice(0, 2);
    if (saved !== currentLang && i18n.language !== saved) {
      i18n.changeLanguage(saved);
    }
  }, [i18n]);

  const changeLang = (code) => {
    const lng = code.slice(0, 2);
    i18n.changeLanguage(lng);
    try { localStorage.setItem('i18nextLng', lng); } catch {}
  };

  const onDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const onDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const next = [...languages];
    const [moved] = next.splice(draggedIndex, 1);
    next.splice(dropIndex, 0, moved);
    setLanguages(next);
    setDraggedIndex(null);
  };

  const onDragEnd = () => setDraggedIndex(null);

  return (
    <div className="language-switcher-inline-wrapper">
      
      <div className="lang-inline" onClick={() => setShowDropdown((v) => !v)} role="button" aria-label="Open language selector">
        <img
          src={currentLanguage?.flagUrl}
          alt={`${currentLanguage?.name || 'Unknown'} flag`}
          className="current-flag-image"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'inline';
          }}
        />
        <span
          className="current-flag-fallback"
          style={{ display: 'none' }}
          role="img"
          aria-label={`Flag for ${currentLanguage?.name || 'Unknown'}`}
        >
          {currentLanguage?.flag || '🌍'}
        </span>
        <span className="current-lang">{currentLang.toUpperCase()}</span>
      </div>

      {showDropdown && (
        <div className="language-switcher-dropdown" onMouseLeave={() => setShowDropdown(false)}>
          <div className="language-list">
            {languages.map((language, index) => (
              <div
                key={language.code}
                className={`language-item ${currentLang === language.code ? 'active' : ''}`}
                onDragOver={onDragOver}
                onDrop={(e) => onDrop(e, index)}
              >
                <img
                  src={language.flagUrl}
                  alt={`${language.name} flag`}
                  className="language-flag-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'inline';
                  }}
                />
                <span
                  className="language-flag-fallback"
                  style={{ display: 'none' }}
                  role="img"
                  aria-label={`${language.name} flag`}
                >
                  {language.flag}
                </span>
                <div className="language-info" onClick={() => changeLang(language.code)}>
                  <span className="language-name">{language.name}</span>
                  <span className="language-code">{language.code.toUpperCase()}</span>
                </div>
                <div
                  className="drag-handle"
                  draggable
                  onDragStart={(e) => onDragStart(e, index)}
                  onDragEnd={onDragEnd}
                  onClick={(e) => e.stopPropagation()}
                  title="Drag to reorder"
                >
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;